import { Routes, Route, Navigate } from 'react-router-dom';
import RequireAuth from '@rbac/RequireAuth';
import { RequirePermission } from '@rbac/Can';
import DefaultLayout from '@layouts/DefaultLayout';
import { buildRoutes } from '@/routes';
import { useModules } from '@/modules';
import Login from '@pages/Login';
import Unauthorized from '@pages/Unauthorized';
import NotFound from '@pages/NotFound';
import Embed from '@pages/Embed';

export default function App() {
  const routes = buildRoutes(useModules());
  return (
    <Routes>
      {/* public */}
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      {/*
        The embeddable player. Public and outside DefaultLayout on purpose: it is loaded
        inside an <iframe> on other people's sites, where a sidebar, a nav bar and a login
        redirect would all be wrong. Access is decided per-video by the API (see
        routes/video.js), not by a route guard here.
      */}
      <Route path="/embed/:publicId" element={<Embed />} />

      {/* protected */}
      <Route element={<RequireAuth />}>
        <Route element={<DefaultLayout />}>
          {routes.map((r) => (
            <Route
              key={r.path}
              path={r.path}
              element={<RequirePermission module={r.module} action={r.action}>{r.element}</RequirePermission>}
            />
          ))}
        </Route>
      </Route>

      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
